// @flow
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {Card, CardActionArea, CardMedia, Checkbox} from '@material-ui/core';
import {PhotoLibrary} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';

export type InstagramImageType = {
  id: string,
  caption?: string,
  media_type: string,
  media_url: string,
  permalink: string,
  timestamp: string,
  username: string,
};

type Props = {
  image: InstagramImageType,
  handleImageSelect: (image: InstagramImageType) => void,
  selected: boolean,
  isAlbum: boolean,
};
const useStyles = props =>
  makeStyles(theme => ({
    cardRoot: {
      position: 'relative',
      margin: `0 ${theme.spacing(3)} ${theme.spacing(3)} 0`,
      height: 224,
      width: 224,
      boxShadow: 'unset',
      [theme.breakpoints.down('xs')]: {
        height: 142,
        width: 142,
      },
    },
    cardActionArea: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      height: '100%',
      borderRadius: '8px',
    },
    cardMedia: {
      borderRadius: '8px',
      height: 248,
      width: '100%',
      // filter:
      //   props.product && !props.product.enabled ? 'grayscale(100%)' : null,
      transition: 'opacity 0.2s, filter 0.2s',
      [theme.breakpoints.down('xs')]: {
        maxHeight: 200,
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    checkboxContainer: {
      position: 'absolute',
      top: 5,
      right: 5,
      zIndex: 3,
      transform: 'scale(1.5)',
      '&:not(checked) .MuiIconButton-label:after': {
        content: '""',
        // left: 4,
        // top: 4,
        height: 14,
        width: 14,
        position: 'absolute',
        backgroundColor: 'white',
        zIndex: -1,
      },
    },
    isAlbum: {
      position: 'absolute',
      bottom: 5,
      left: 5,
      zIndex: 3,
      background: colors.grey200,
      borderRadius: '20px',
      padding: 6,
      opacity: 0.8,
    },
  }));

export default function InstagramImage(props: Props) {
  const {image, handleImageSelect, selected, isAlbum} = props;
  const classes = useStyles(props)();

  // const mobile = useMediaQuery('(max-width:600px)');

  return image ? (
    <Card className={classes.cardRoot}>
      {handleImageSelect && (
        <Checkbox
          color="primary"
          className={classes.checkboxContainer}
          checked={selected}
          onChange={() => handleImageSelect(image)}
        />
      )}
      {isAlbum && (
        <div className={classes.isAlbum}>
          <PhotoLibrary style={{display: 'block'}} fontSize="small" />
        </div>
      )}
      <CardActionArea
        className={classes.cardActionArea}
        onClick={() => handleImageSelect(image)}
      >
        <CardMedia
          classes={{root: classes.cardMedia}}
          image={image.media_url}
        />
      </CardActionArea>
    </Card>
  ) : null;
}

InstagramImage.propTypes = {
  image: PropTypes.object,
  selected: PropTypes.bool,
  handleSelect: PropTypes.func,
  isAlbum: PropTypes.bool,
};
